export type CannyUserHashResponse = { userHash: string };

class CannyUserHashApiClass {
  private async api<T>(url: string): Promise<T> {
    const API_PREFIX = '/api';

    return fetch(`${API_PREFIX}${url}`).then(response => {
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      return response.json() as Promise<T>;
    });
  }

  public async getUserHash(): Promise<CannyUserHashResponse> {
    return this.api<CannyUserHashResponse>('/canny-user-hash');
  }
}

export const CannyUserHashApi = new CannyUserHashApiClass();
